import * as React from 'react';

function SvgGooglePlusMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.912 13.014H10.08v2.798h4.69c-.677 2.003-2.547 3.443-4.749 3.443C7.248 19.255 5 16.97 5 14.15c0-2.818 2.249-5.104 5.023-5.104 1.216 0 2.327.44 3.195 1.17h.132l2.066-2.1A7.93 7.93 0 0010.022 6C5.592 6 2 9.65 2 14.15c0 4.503 3.592 8.15 8.022 8.15a7.926 7.926 0 004.887-1.685 8.194 8.194 0 002.861-4.346c.158-.599.151-1.2.145-1.813-.002-.123-.003-.247-.003-.372v-1.069zm4.959 4.623h2.35v-2.335h2.336v-2.35h-2.336v-2.336h-2.35v2.337h-2.335v2.349h2.334v2.335z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgGooglePlusMono;
